import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { requireInventoryUserId } from "../lib/auth.server"
import { createVendor, listVendors, updateVendor } from "../lib/vendors.server"

export const listVendorsFn = createServerFn({ method: "GET" })
  .validator((data?: { includeInactive?: boolean }) => data)
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return listVendors(data)
  })

export const createVendorFn = createServerFn({ method: "POST" })
  .validator((data: unknown) => z.object({ name: z.string() }).parse(data))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return createVendor(data.name)
  })

export const updateVendorFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        id: z.number(),
        name: z.string().optional(),
        isActive: z.boolean().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return updateVendor(data)
  })
